export const eyeIcon = [
  "24 24",
  `
  <path xmlns="http://www.w3.org/2000/svg" data-name="eye" d="M382.027,89.874C297.585,20.361,172.536,25.063,93.6,104c-83.947,83.947-83.947,220.053,0,304,78.937,78.937,203.986,83.639,288.428,14.126L215.9,256Z" />
  <path xmlns="http://www.w3.org/2000/svg" data-name="eye" d="M435.026,96.273,275.3,256,435.026,415.728a247.716,247.716,0,0,0,0-319.455Z" />
    
  `,
];
